import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle';

const enumer = {
  sheetId: {
    title: '账单编号',
    key: 'sheetId',
    minWidth: 190,
    align: 'center',
    fixed: 'left'
  },
  bankId: {
    title: '银行',
    slot: 'bankId',
    minWidth: 100,
    align: 'center'
  },
  orgName: {
    title: '机构名称',
    slot: 'orgName',
    width: tableColumnsWidth.type6,
    align: 'center',
    fixed: 'left'
  },

  settlePeriod: {
    title: '账单周期',
    key: 'settlePeriod',
    minWidth: 220,
    align: 'center'
  },

  yearTerm: {
    title: '学期',
    key: 'yearTerm',
    minWidth: 200,
    align: 'center'
  },
  commission: {
    key: 'commission',

    minWidth: 150,
    align: 'center',

    renderHeader: (h, params) => {
      return h(
        'Tooltip',
        { props: { placement: 'top', transfer: true, 'max-width': '300' }}, // 提示组件的属性
        [
          h('span', [
            h('span', '手续费（合计）'), // 列名
            h('Icon', { props: { type: 'ios-alert-outline' }}) // 问号图标
          ]),
          h(
            'span',
            {
              slot: 'content'
            },
            '账单的结算订单中结算部分所有结算金额的手续费金额之和。'
          ) // 提示内容
        ]
      );
    }
  },
  platformPoundage: {
    key: 'platformPoundage',
    minWidth: 170,
    align: 'center',
    renderHeader: (h, params) => {
      return h(
        'Tooltip',
        { props: { placement: 'top', transfer: true, 'max-width': '300' }}, // 提示组件的属性
        [
          h('span', [
            h('span', '手续费（平台方）'), // 列名
            h('Icon', { props: { type: 'ios-alert-outline' }}) // 问号图标
          ]),
          h(
            'span',
            {
              slot: 'content'
            },
            '账单的结算订单中结算部分所有结算金额中平台方承担的手续费金额之和。'
          ) // 提示内容
        ]
      );
    }
  },
  merchantPoundage: {
    key: 'merchantPoundage',
    minWidth: 170,
    align: 'center',
    renderHeader: (h, params) => {
      return h(
        'Tooltip',
        { props: { placement: 'top', transfer: true, 'max-width': '300' }}, // 提示组件的属性
        [
          h('span', [
            h('span', '手续费（机构方）'), // 列名
            h('Icon', { props: { type: 'ios-alert-outline' }}) // 问号图标
          ]),
          h(
            'span',
            {
              slot: 'content'
            },
            '账单的结算订单中结算部分所有结算金额中机构方承担的手续费金额之和。'
          ) // 提示内容
        ]
      );
    }
  },
  settleCycle: {
    title: '账期周期',
    slot: 'settleCycle',
    minWidth: 150,
    align: 'center'
  },
  billingDate: {
    title: '账单日',
    key: 'billingDate',
    minWidth: 180,
    align: 'center'
  },
  availBal: {
    title: '期初金额（元）',
    key: 'availBal',
    minWidth: 120,
    align: 'center'
  },
  daycare: {
    title: '托管费（元）',
    key: 'daycare',
    minWidth: 120,
    align: 'center'
  },
  settleAvailAmt: {
    title: '结算金额（元) ',
    key: 'settleAvailAmt',
    minWidth: 150,
    align: 'center',
    renderHeader: (h, params) => {
      return h(
        'Tooltip',
        { props: { placement: 'top', transfer: true, 'max-width': '300' }}, // 提示组件的属性
        [
          h('span', [
            h('span', '结算金额（元) '), // 列名
            h('Icon', { props: { type: 'ios-alert-outline' }}) // 问号图标
          ]),
          h(
            'span',
            {
              slot: 'content'
            },
            '账单的订单中结算部分的所有结算金额之和。'
          ) // 提示内容
        ]
      );
    }
  },
  platTotalAmt: {
    title: '平台服务费（元)',
    key: 'platTotalAmt',
    minWidth: 160,
    align: 'center',
    renderHeader: (h, params) => {
      return h(
        'Tooltip',
        { props: { placement: 'top', transfer: true, 'max-width': '300' }}, // 提示组件的属性
        [
          h('span', [
            h('span', '平台服务费（元)'), // 列名
            h('Icon', { props: { type: 'ios-alert-outline' }}) // 问号图标
          ]),
          h(
            'span',
            {
              slot: 'content'
            },
            '账单的结算订单中结算部分平台对应的服务费之和（含手续费部分）。'
          ) // 提示内容
        ]
      );
    }
  },
  platAmtForSchool: {
    title: '平台服务费（元)',
    key: 'platAmt',
    minWidth: 220,
    align: 'center',
    renderHeader: (h, params) => {
      return h(
        'Tooltip',
        { props: { placement: 'top', transfer: true, 'max-width': '300' }}, // 提示组件的属性
        [
          h('span', [
            h('span', '平台服务费（元）'), // 列名
            h('Icon', { props: { type: 'ios-alert-outline' }}) // 问号图标
          ]),
          h(
            'span',
            {
              slot: 'content'
            },
            '账单的结算订单中结算部分平台对应的实际服务费之和。'
          ) // 提示内容
        ]
      );
    }
  },
  platAmt: {
    title: '平台服务费(到账) (元)',
    key: 'platAmt',
    minWidth: 220,
    align: 'center',
    renderHeader: (h, params) => {
      return h(
        'Tooltip',
        { props: { placement: 'top', transfer: true, 'max-width': '300' }}, // 提示组件的属性
        [
          h('span', [
            h('span', '平台服务费(到账) (元)'), // 列名
            h('Icon', { props: { type: 'ios-alert-outline' }}) // 问号图标
          ]),
          h(
            'span',
            {
              slot: 'content'
            },
            '账单的结算订单中结算部分平台对应的实际服务费之和。'
          ) // 提示内容
        ]
      );
    }
  },
  merchantAmt: {
    title: '机构应结算金额（元) ',
    key: 'merchantAmt',
    minWidth: 190,
    align: 'center',
    renderHeader: (h, params) => {
      return h(
        'Tooltip',
        { props: { placement: 'top', transfer: true, 'max-width': '300' }}, // 提示组件的属性
        [
          h('span', [
            h('span', '机构应结算金额（元) '), // 列名
            h('Icon', { props: { type: 'ios-alert-outline' }}) // 问号图标
          ]),
          h(
            'span',
            {
              slot: 'content'
            },
            '账单的结算订单中结算部分机构对应的实际结算金额之和。'
          ) // 提示内容
        ]
      );
    }
  },
  realPlatAmt: {
    title: '平台服务费（元）（实际）',
    key: 'realPlatAmt',
    minWidth: 170,
    align: 'center'
  },
  endAvailBal: {
    title: '期末金额（元）',
    key: 'endAvailBal',
    minWidth: 120,
    align: 'center'
  },
  tallyCount: {
    title: '结算笔数',
    key: 'tallyCount',
    minWidth: 110,
    align: 'center'
  },

  attachmentPrice: {
    title: '材料费（元）',
    key: 'attachmentPrice',
    minWidth: 120,
    align: 'center'
  },
  classroomFee: {
    title: '课程费（元）',
    key: 'classroomFee',
    minWidth: 120,
    align: 'center'
  },
  totalFee: {
    title: '合计结算',
    key: 'totalFee',
    minWidth: 120,
    align: 'center'
  },
  orgFee: {
    title: '机构应结算',
    key: 'orgFee',
    minWidth: 120,
    align: 'center'
  },
  settleMonth: {
    title: '结算月份',
    key: 'settleMonth',
    minWidth: 130,
    align: 'center',
    fixed: 'left'
  },
  eduName: {
    title: '服务区域',
    key: 'eduName',
    minWidth: 150,
    align: 'center'
  },
  approvalSts: {
    title: '对账情况',
    slot: 'approvalSts',
    minWidth: 120,
    align: 'center'
  },
  settleSts: {
    title: '结算情况',
    slot: 'settleSts',
    minWidth: 120,
    align: 'center'
  },
  settleTime: {
    title: '账单结算完成时间',
    key: 'settleTime',
    minWidth: 180,
    align: 'center'
  },
  settleTimeBegin: {
    title: '账单结算开始时间',
    key: 'settleTimeBegin',
    minWidth: 180,
    align: 'center'
  },
  settlementTime: {
    title: '结算时间',
    key: 'settleStsTime',
    minWidth: 180,
    align: 'center'
  },
  action: {
    title: '操作',
    slot: 'action',
    width: 200,
    align: 'center',
    fixed: 'right'
  }
};

const billColumn = [];

const mapData = {
  1: [
    enumer['sheetId'],
    enumer['orgName'],
    enumer['settleMonth'],
    enumer['eduName'],
    enumer['bankId'],
    {
      title: '收款单位',
      key: 'settlementSheetOrgName',
      minWidth: 230,
      align: 'center'
    },
    {
      title: '服务学校',
      key: 'schoolName',
      minWidth: 230,
      align: 'center'
    },
    enumer['settlePeriod'],
    {
      title: '午托费',
      key: 'noonCareAmt',
      minWidth: 130,
      align: 'center'
    },
    {
      title: '基本托管费',
      key: 'lateCareAmt',
      minWidth: 130,
      align: 'center'
    },
    {
      title: '晚自修费用',
      key: 'fullCareAmt',
      minWidth: 130,
      align: 'center'
    },
    {
      title: '材料费',
      key: 'attachmentPrice',
      minWidth: 130,
      align: 'center'
    },
    {
      title: '素质课程费',
      key: 'classroomFee',
      minWidth: 130,
      align: 'center'
    },
    enumer['settleAvailAmt'],
    enumer['platTotalAmt'],
    enumer['platAmt'],
    enumer['merchantAmt'],
    enumer['commission'],
    enumer['tallyCount'],

    enumer['approvalSts'],
    enumer['settleCycle'],
    enumer['settleSts'],
    enumer['billingDate'],
    enumer['settleTime'],
    enumer['action']
  ],
  2: [
    {
      title: '学校名称',
      slot: 'schoolName',
      width: tableColumnsWidth.type6,
      align: 'center',
      fixed: 'left'
    },
    enumer['bankId'],

    {
      title: '结算月份',
      key: 'settleMonth',
      minWidth: 130,
      align: 'center'
    },
    enumer['yearTerm'],
    {
      title: '午托费',
      key: 'noonCare',
      minWidth: 130,
      align: 'center'
    },
    {
      title: '基本托管费',
      key: 'lateCare',
      minWidth: 130,
      align: 'center'
    },
    {
      title: '晚自修费用',
      key: 'fullCare',
      minWidth: 130,
      align: 'center'
    },
    {
      title: '材料费',
      key: 'attachmentPrice',
      minWidth: 130,
      align: 'center'
    },

    {
      title: '素质课程费',
      key: 'classroomFee',
      minWidth: 130,
      align: 'center'
    },

    {
      title: '结算金额（元)',
      key: 'totalFee',
      minWidth: 120,
      align: 'center'
    }, // settleAvailAmt
    {
      title: '平台服务费（元）',
      key: 'platServiceFee',
      minWidth: 120,
      align: 'center'
    },
    // enumer['platAmt'],
    {
      title: '结算时间',
      key: 'settleTimeBegin',
      minWidth: 180,
      align: 'center'
    },
    enumer['action']
  ],
  3: [
    // enumer['sheetId'],
    enumer['yearTerm'],
    enumer['daycare'],

    enumer['attachmentPrice'],
    enumer['classroomFee'],
    enumer['totalFee'],
    enumer['settleMonth'],
    enumer['settlementTime'],
    enumer['action']
  ],
  // 运营端-机构账单列表
  4: [
    {
      type: 'selection',
      width: 60,
      align: 'center',
      fixed: 'left'
    },
    enumer['sheetId'],
    enumer['orgName'],
    enumer['settleMonth'],
    enumer['eduName'],
    enumer['bankId'],
    {
      title: '收款单位',
      key: 'settlementSheetOrgName',
      minWidth: 230,
      align: 'center'
    },
    {
      title: '服务学校',
      key: 'schoolName',
      minWidth: 230,
      align: 'center'
    },
    enumer['settlePeriod'],
    enumer['yearTerm'],
    {
      title: '午托费',
      key: 'noonCareAmt',
      minWidth: 130,
      align: 'center'
    },
    {
      title: '基本托管费',
      key: 'lateCareAmt',
      minWidth: 130,
      align: 'center'
    },
    {
      title: '晚自修费用',
      key: 'fullCareAmt',
      minWidth: 130,
      align: 'center'
    },
    {
      title: '材料费',
      key: 'attachmentPrice',
      minWidth: 130,
      align: 'center'
    },
    {
      title: '素质课程费',
      key: 'classroomFee',
      minWidth: 130,
      align: 'center'
    },
    enumer['settleAvailAmt'],
    enumer['platTotalAmt'],
    enumer['platAmt'],
    // enumer['realPlatAmt'],

    enumer['merchantAmt'],
    enumer['commission'],
    enumer['platformPoundage'],
    enumer['merchantPoundage'],
    enumer['tallyCount'],

    enumer['approvalSts'],
    enumer['settleSts'],
    enumer['settleCycle'],
    enumer['billingDate'],
    enumer['settleTimeBegin'],
    enumer['settleTime'],
    enumer['action']
  ]
};

export function getColumn(key = 1) {
  return mapData[key];
}
